import { render, staticRenderFns } from "./UserGroup.vue?vue&type=template&id=5d25e62e"
import script from "./UserGroup.vue?vue&type=script&lang=js"
export * from "./UserGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports